// extracted by mini-css-extract-plugin
module.exports = {"bannerImage":"styles_bannerImage__1wcIc"};